import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, catchError, map, throwError } from 'rxjs';
import { RoleViewService } from './role-view.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
}

const WORKDAY_ID_PARAM = '?workDayId=';

@Injectable({
  providedIn: 'root'
})
export class ManageCollectionsService {
  pathUrl = environment?.baseApiUrl + environment?.projectApiPath;
  superAdminUrl = environment?.baseApiUrl + environment?.superAdminApiPath;
  userUuid = '';

  constructor(private readonly http: HttpClient,private readonly roleViewService:RoleViewService) { 
        this.roleViewService.getUserName$().subscribe(uuid => {
          this.userUuid = uuid;
        }); }

  fetchCollections(_workDayId: string): Observable<any> {
    const url = `${this.superAdminUrl}fetchCollectionWithSubCollection${environment?.proxy}${WORKDAY_ID_PARAM}${this.userUuid}`;
    return this.http.get(url, httpOptions)
      .pipe(map((response: any) => response));
  }

  saveCollections( request: any): Observable<any> {
    const url = `${this.pathUrl}saveCollectionNames${environment?.proxy}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  saveCollectionWithSubCollections(_workDayId: string, request: any): Observable<any> {
    const url = `${this.pathUrl}saveColWithSubCollection${environment?.proxy}${WORKDAY_ID_PARAM}${this.userUuid}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  saveSubCollections(_workDayId: string, request: any): Observable<any> {
    const url = `${this.pathUrl}saveSubCollectionNames${environment?.proxy}${WORKDAY_ID_PARAM}${this.userUuid}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  updateCollection(_workDayId: string, request: any): Observable<any> {
    const url = `${this.superAdminUrl}updateManageCollection${environment?.proxy}${WORKDAY_ID_PARAM}${this.userUuid}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  updateSubCollection(_workDayId: string, request: any): Observable<any> {
    const url = `${this.superAdminUrl}updateManageSubCollection${environment?.proxy}${WORKDAY_ID_PARAM}${this.userUuid}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  deleteCollection(collectionId: string, updatedBy: string, isDeleted = true): Observable<any> {
    const url = `${this.superAdminUrl}deleteManageCollection${environment?.proxy}?collectionId=${collectionId}`;
    const request = { 
      collectionId: collectionId,
      isDeleted: isDeleted,
      updatedBy: updatedBy
    };
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  deleteSubCollection(collectionId: string, subCollectionId: string, _workDayId: string, updatedBy: string, isDeleted = true): Observable<any> {
    const url = `${this.superAdminUrl}deleteManageSubCollection${environment?.proxy}${WORKDAY_ID_PARAM}${this.userUuid}`;
    const request = { 
      collectionId: collectionId,
      subCollectionId: subCollectionId,
      updatedBy: updatedBy,
      isDeleted: isDeleted
    };
    console.info('deleteSubCollection - URL:', url);
    console.info('deleteSubCollection - Request:', request);
    return this.http.post(url, request, httpOptions)
      .pipe(
        map((response: any) => {
          console.info('deleteSubCollection - Response:', response);
          return response;
        }),
        catchError((error: any) => {
          console.trace('deleteSubCollection - Error:', error);
          return throwError(() => error);
        })
      );
  }

  private handleError(error: HttpErrorResponse) {
    let errorMsg = '';
    if (error.error instanceof ErrorEvent) {
      errorMsg = `An error occurred: ${error.error.message}`;
    } else {
      errorMsg = `Backend returned code ${error.status}`;
    }
    return throwError(() => new Error(errorMsg));
  }
}